'use client';

import React, { useState, useEffect, createContext, useContext } from 'react';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { getPublicGoogleAuth } from '@/lib/api-client';

const GoogleClientIdContext = createContext<string | null>(null);

export function useGoogleClientId() {
  return useContext(GoogleClientIdContext);
}

export default function GoogleAuthWrapper({ children }: { children: React.ReactNode }) {
  const [clientId, setClientId] = useState<string | null>(null);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    getPublicGoogleAuth()
      .then((data) => setClientId(data.clientId || null))
      .catch(() => {})
      .finally(() => setLoaded(true));
  }, []);

  // Don't block rendering while loading — children render immediately
  if (!loaded || !clientId) {
    return (
      <GoogleClientIdContext.Provider value={clientId}>
        {children}
      </GoogleClientIdContext.Provider>
    );
  }

  return (
    <GoogleOAuthProvider clientId={clientId}>
      <GoogleClientIdContext.Provider value={clientId}>
        {children}
      </GoogleClientIdContext.Provider>
    </GoogleOAuthProvider>
  );
}
